(ns frontend.view.components.form.components.form-url
  (:require [reagent.core :as r]
            [frontend.utils :as utils :refer [truncate-url]]
            [frontend.view.components.form.components.form-label :as form-label]
            [frontend.view.components.form.components.form-cancel-button :as cancel-button]
            [frontend.bootstrap.components :as rbs]))

(defn view
  [{:keys [value]}]
  (let [raw-input (r/atom value)
        has-focus (r/atom false)]
    (fn [{:keys [entity type size value intelligence-value wrapper control-id
                 info field read-only? on-change! on-submit! on-cancel!] :as view-args}]
      (let [on-cancel! (fn [e]
                         (reset! raw-input nil)
                         (on-cancel! e))
            href-value (when (not-empty value)
                         (utils/->proper-url value))
            on-key-down! (fn [e]
                           (let [key (.-keyCode e)]
                             (when (= key 13)
                               ;; Enter
                               (-> e .-target .blur))
                             (when (= key 27)               ;;esc handling
                               (on-cancel! e)
                               (-> e .-target .blur))))]
        [rbs/Form
         {:on-submit (fn [e]
                       (on-change! @raw-input)
                       (on-submit! e))
          :on-blur   (fn [e]
                       (let [targetType (-> e .-target .-nodeName)]
                         (if (and (= targetType "INPUT")
                                  @raw-input
                                  (not= @raw-input value))
                           (on-submit! e)
                           (on-cancel! e))))}
         [rbs/FormGroup
          {:control-id control-id
           :size       size
           :class-name (str wrapper " form__text")}
          [form-label/view (merge view-args
                                  {:intelligence-value intelligence-value})]
          [rbs/InputGroup
           [:input {:placeholder ""
                    :type        type
                    :id          control-id
                    :class-name  (str "form-control")
                    :disabled    (boolean read-only?)
                    :value       (or (if (nil? @raw-input)
                                       (or value intelligence-value)
                                       @raw-input) "")
                    :on-change   (fn [e]
                                   (let [input (-> e .-target .-value utils/->proper-url)]
                                     (reset! raw-input input)))
                    :on-blur     #(do (reset! has-focus false)
                                      (on-change! @raw-input))
                    :on-focus    #(reset! has-focus true)
                    :on-key-down on-key-down!}]
           (if @has-focus
             [cancel-button/view on-cancel!]
             (when (not-empty value)
               [:a.zap-btn__hollow-borderless__green.btn.btn-default
                {:href   href-value
                 :target "_blank"
                 :role   "button"}
                [:i.fal.fa-external-link]]))]]]))))
